import React from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import Header from '../../Header'
import Footer from '../../Footer'
import { setUIBackwardsAction } from '../../../actions'
import { updateReservationAndGoConfirmReservationInfoAction, isTruckTrailer } from '../../../actions/reservation'
import { UI } from '../../../constants/ui'
import { AppState } from '../../../reducers'
import { countries } from '../../../constants/countries'
import _ from 'lodash'
import './summary.less'
import FooterMobile from '../../FooterMobile'
import { getMode } from '../../../hooks/mode'
import { MODE } from '../../../constants/mode'

const mapStateToProps = (state: AppState) => ({
  reservation: state.reservation.reservation,
  reservationChange: state.reservationChange,
  isDocumentRequires: state.reservation.isDocumentRequires,
})

const mapDispatchToProps = {
  setUIBackwards: setUIBackwardsAction,
  updateReservationAndGoConfirmReservationInfo: updateReservationAndGoConfirmReservationInfoAction,
}

type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = typeof mapDispatchToProps
type Props = StateProps & DispatchProps

interface CustomProps {
  back: () => void
  from: string
  to: string
  returnCountry: (country?: string) => string
  returnGender: (gender: string) => "male" | "female"
}

type SummaryExtendedProps = CustomProps & Pick<Props, 'reservation' | 'reservationChange' | 'updateReservationAndGoConfirmReservationInfo'>

const SummaryMobile: React.FC<SummaryExtendedProps> = ({ back, reservation, reservationChange, from, to, returnCountry, returnGender, updateReservationAndGoConfirmReservationInfo }) => {
  const { t } = useTranslation()

  if (!reservation || !reservationChange) {
    return null
  }
  return (
    <div className="summary-mobile">
      <div className="summary-mobile-wrapper">
        <div className="summary-title" dangerouslySetInnerHTML={{ __html: t('summary') }}></div>
        <div className="summary-data">
          <div className="about-cargo-and-way">
            <div>
              {t(reservation.cargoType) + ','} {reservationChange.cargoLength} {t('meter')}
              <br />
              <span className="text-bold">{reservation.cargoUnit.regNumber}</span>{' '}
              {isTruckTrailer(reservationChange) ? `+ ${reservationChange.trailerLicencePlate}` : null}
            </div>
            <div className="summary-block-info">
              <span dangerouslySetInnerHTML={{ __html: t(reservationChange.cargoContent)}}></span>
              <br />
              {reservationChange.cargoWeight} {t('kilogram')}
            </div>
            <div className="summary-block-info">
              {t(`countries:${from}`)}
              {' → '}
              {t(`countries:${to}`)}
            </div>
          </div>
          <div className="about-passengers">
            <div className="driver driver1">
              <span className="text-bold">
                {reservationChange.drivers[0].firstName} {reservationChange.drivers[0].lastName}
              </span>
              <br />
              {t(`countries:${returnCountry(reservationChange.drivers[0].citizenship)}`)},{' '}
              {reservationChange.drivers[0].birthDate}, {t(returnGender(reservationChange.drivers[0].gender))}
              <br />
              {reservationChange.drivers[0].docType && t(reservationChange.drivers[0].docType) + ','}{' '}
              {reservationChange.drivers[0].docNumber && reservationChange.drivers[0].docNumber + ','}{' '}
              {reservationChange.drivers[0].docIssuedCountry &&
                t(`countries:${returnCountry(reservationChange.drivers[0].docIssuedCountry)}`) + ','}{' '}
              {reservationChange.drivers[0].docExpirationDate}
            </div>
            {reservationChange.drivers.length > 1 ? (
              <div className="driver driver2">
                <span className="text-bold">
                  {reservationChange.drivers[1].firstName} {reservationChange.drivers[1].lastName}
                </span>
                <br />
                {t(`countries:${returnCountry(reservationChange.drivers[1].citizenship)}`)},{' '}
                {reservationChange.drivers[1].birthDate}, {t(returnGender(reservationChange.drivers[1].gender))}
                <br />
                {reservationChange.drivers[1].docType && t(reservationChange.drivers[1].docType) + ','}{' '}
                {reservationChange.drivers[1].docNumber && reservationChange.drivers[1].docNumber + ','}{' '}
                {reservationChange.drivers[1].docIssuedCountry &&
                  t(`countries:${returnCountry(reservationChange.drivers[1].docIssuedCountry)}`) + ','}{' '}
                {reservationChange.drivers[1].docExpirationDate}
              </div>
            ) : (
              <div></div>
            )}
          </div>
        </div>
        <div className="continue-button">
          <button className="main-button-mobile" onClick={() => updateReservationAndGoConfirmReservationInfo()}>
            {t('continue')}
          </button>
        </div>
      </div>
      <div className="footer-mobile-container">
        <FooterMobile showPageCount back={back} />
      </div>
    </div>
  )
}

const SummaryDesktop: React.FC<SummaryExtendedProps> = ({ back, reservation, reservationChange, from, to, returnCountry, returnGender, updateReservationAndGoConfirmReservationInfo }) => {
  const { t } = useTranslation()
  if (!reservation || !reservationChange) {
    return null
  }
  return (
    <>
      <Header showPageCount back={back} />
      <div className="summary">
        <div className="summary-title" dangerouslySetInnerHTML={{ __html: t('summary') }}></div>
        <div className="summary-data">
          <div className="about-cargo-and-way">
            <div>
              {t(reservation.cargoType) + ','} {reservationChange.cargoLength} {t('meter')}
              <br />
              <span className="text-bold">{reservation.cargoUnit.regNumber}</span>{' '}
              {isTruckTrailer(reservationChange) ? `+ ${reservationChange.trailerLicencePlate}` : null}
            </div>
            <div className="summary-block-info">
              <span dangerouslySetInnerHTML={{ __html: t(reservationChange.cargoContent)}}></span>
              <br />
              {reservationChange.cargoWeight} {t('kilogram')}
            </div>
            <div className="summary-block-info">
              {t(`countries:${from}`)}
              {' → '}
              {t(`countries:${to}`)}
            </div>
          </div>
          <div className="about-passengers">
            <div className="driver driver1">
              <span className="text-bold">
                {reservationChange.drivers[0].firstName} {reservationChange.drivers[0].lastName}
              </span>
              <br />
              {t(`countries:${returnCountry(reservationChange.drivers[0].citizenship)}`)},{' '}
              {reservationChange.drivers[0].birthDate}, {t(returnGender(reservationChange.drivers[0].gender))}
              <br />
              {reservationChange.drivers[0].docType && t(reservationChange.drivers[0].docType) + ','}{' '}
              {reservationChange.drivers[0].docNumber && reservationChange.drivers[0].docNumber + ','}{' '}
              {reservationChange.drivers[0].docIssuedCountry &&
                t(`countries:${returnCountry(reservationChange.drivers[0].docIssuedCountry)}`) + ','}{' '}
              {reservationChange.drivers[0].docExpirationDate}
            </div>
            {reservationChange.drivers.length > 1 ? (
              <div className="driver driver2">
                <span className="text-bold">
                  {reservationChange.drivers[1].firstName} {reservationChange.drivers[1].lastName}
                </span>
                <br />
                {t(`countries:${returnCountry(reservationChange.drivers[1].citizenship)}`)},{' '}
                {reservationChange.drivers[1].birthDate}, {t(returnGender(reservationChange.drivers[1].gender))}
                <br />
                {reservationChange.drivers[1].docType && t(reservationChange.drivers[1].docType) + ','}{' '}
                {reservationChange.drivers[1].docNumber && reservationChange.drivers[1].docNumber + ','}{' '}
                {reservationChange.drivers[1].docIssuedCountry &&
                  t(`countries:${returnCountry(reservationChange.drivers[1].docIssuedCountry)}`) + ','}{' '}
                {reservationChange.drivers[1].docExpirationDate}
              </div>
            ) : (
              <div></div>
            )}
          </div>
        </div>
      </div>
      <div className="continue-button">
        <button className="main-button" onClick={() => updateReservationAndGoConfirmReservationInfo()}>
          {t('continue')}
        </button>
      </div>
      <Footer />
    </>
  )
}

const Summary: React.FC<Props> = ({
  setUIBackwards,
  reservation,
  reservationChange,
  updateReservationAndGoConfirmReservationInfo,
  isDocumentRequires,
}: Props) => {
  const mode = getMode()
  const returnGender = (gender: string) => {
    return gender === 'M' ? 'male' : 'female'
  }
  const returnCountry = (country?: string) => {
    if (!country) {
      return ''
    }
    const data = _.find(countries, (item) => item.code.includes(country.toUpperCase()))
    return data ? data.code : ''
  }
  if (!reservation || !reservationChange) {
    return null
  }
  const from = returnCountry(reservationChange.countryFrom)
  const to = returnCountry(reservationChange.countryTo)

  const back = () => {
    if (reservation.drivers[1]) {
      if (isDocumentRequires) {
        setUIBackwards(UI.DOCUMENT2_INFORMATION)
      } else {
        setUIBackwards(UI.DRIVER2_INFORMATION)
      }
    } else {
      if (isDocumentRequires) {
        setUIBackwards(UI.DOCUMENT_INFORMATION)
      } else {
        setUIBackwards(UI.DRIVERS_INFORMATION)
      }
    }
  }

  const mobileBack = () => {
    if (reservation.drivers[1]) {
      setUIBackwards(UI.DRIVER2_INFORMATION_AND_DOCUMENT_MOBILE)
    } else {
      setUIBackwards(UI.DRIVERS_INFORMATION_AND_DOCUMENT_MOBILE)
    }
  }

  const customProps = { reservation, reservationChange, from, to, returnCountry, returnGender, updateReservationAndGoConfirmReservationInfo }
  if (mode === MODE.MOBILE) {
    return <SummaryMobile {...customProps} back={mobileBack} />
  } else {
    return <SummaryDesktop {...customProps} back={back} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Summary)
